import { render, staticRenderFns } from "./InvestorMainOnboardingStepPagePf.vue?vue&type=template&id=643d2a01&"
import script from "./InvestorMainOnboardingStepPagePf.vue?vue&type=script&lang=js&"
export * from "./InvestorMainOnboardingStepPagePf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports